<template>
  <MainLayout>
    <div class="container mw-960" slot="sub-header">
      <div class="row">
        <div class="col-12 hidden-xs-down">
          <div class="sub-header-btn-row">
            <Tooltip
              position="bottom"
              v-bind:show="showTooltip"
              v-on:tooltip-closed="onTooltipClosed"
            >
              <button class="btn btn-primary new-my-card-link"
                      v-on:click="goToNewMyCard">
                {{ $t('my_cards.sub_header.new_my_card') }}
              </button>

              <div slot="tooltip-body">
                <div class="typography--body-3 typography--color-secondary"
                     v-html="$t('common.tooltip.try_new_my_card')">
                </div>
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="container mw-960" slot="layout-body">
      <div class="row browse-filter-row">
        <div class="col-12 col-lg-7">
          <div class="row box">
            <div class="col-sm-3 divider">
              <b-dropdown
                class="mnv-dropdown grade-select"
                v-bind:text="getTranslatedName(gradeMap[myCardsFilters.grade_id])"
              >
                <b-dropdown-item v-on:click="selectGrade('0', '0')">
                  {{ $t('common.selects.all_grades') }}
                </b-dropdown-item>
                <b-dropdown-item
                  v-for="(value, key) in gradeList"
                  v-on:click="selectGrade(value.id, value.school_year)"
                  v-bind:key="key"
                >
                  {{ getTranslatedName(gradeMap[value.id]) }}
                </b-dropdown-item>
                <b-dropdown-item v-on:click="selectGrade('null', 'null')">
                  {{ $t('common.selects.others') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="col-sm-3 divider">
              <b-dropdown
                id="subject-dropdown"
                class="mnv-dropdown subject-select"
                v-bind:text="getTranslatedName(subjectMap[myCardsFilters.subject_id])"
              >
                <b-dropdown-item v-on:click="selectSubject('0')">
                  {{ $t('common.selects.all_subjects') }}
                </b-dropdown-item>
                <b-dropdown-item
                  v-for="(value, key) in gradeSubjects"
                  v-on:click="selectSubject(value.id)"
                  v-bind:key="key"
                >
                  {{ getTranslatedName(subjectMap[value.id]) }}
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <!-- Units -->
            <div class="col-sm-6">
              <b-dropdown v-bind:text="getUnitLabel(units[myCardsFilters.unit_id]) || $t('common.browse_filters.all_chapters')" class="mnv-dropdown chapter-select" id="unit-dropdown">
                <b-dropdown-item v-on:click="selectUnit('0')">
                  {{ $t('common.browse_filters.all_chapters') }}
                </b-dropdown-item>

                <b-dropdown-item v-for="unit in currentUnitList"
                                 v-on:click="selectUnit(unit.id)"
                                 v-bind:key="unit.id">
                  {{ getUnitLabel(unit) }}
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <!-- Core Concepts -->
            <!-- <div class="col-sm-6" v-show="getSchoolYear(gradeMap[myCardsFilters.grade_id]) >= 7">
              <b-dropdown v-bind:text="getDetailedCoreConceptLabel(coreConcepts[myCardsFilters.core_concept_id]) || $t('common.browse_filters.all_core_concepts')" class="mnv-dropdown core-concept-select" id="core-concept-dropdown">
                <b-dropdown-item v-on:click="selectCoreConcept('0')">
                  {{ $t('common.browse_filters.all_core_concepts') }}
                </b-dropdown-item>

                <b-dropdown-item v-for="coreConcept in currentCoreConceptList"
                                 v-on:click="selectCoreConcept(coreConcept.id)"
                                 v-bind:key="coreConcept.id"
                                 v-bind:title="`${$t('card_details.card_meta.learning_elements')}: ${coreConcept.description}`">
                  {{ getDetailedCoreConceptLabel(coreConcept) }}
                </b-dropdown-item>
              </b-dropdown>
            </div> -->
          </div>
        </div>
        <div class="col-12 col-lg-5">
          <SearchInput v-bind:model-value="myCardsFilters.search_keywords" v-on:input="applySearchKeywords"></SearchInput>
        </div>
      </div>

      <hr>

      <div class="row browse-filter-row my-cards-filters">
        <div class="col-sm-8">

          <Radio v-on:change="selectMediaType" v-bind:model-value="myCardsFilters.media_type" check-value="all" id="media-type-all">
            <span slot="label">{{ $t('common.browse_filters.media_type.all') }}</span>
          </Radio>

          <Radio v-on:change="selectMediaType" v-bind:model-value="myCardsFilters.media_type" check-value="image" id="media-type-image">
            <span slot="label">{{ $t('common.browse_filters.media_type.image') }}</span>
          </Radio>

          <Radio v-on:change="selectMediaType" v-bind:model-value="myCardsFilters.media_type" check-value="video" id="media-type-video">
            <span slot="label">{{ $t('common.browse_filters.media_type.video') }}</span>
          </Radio>

          <Radio v-on:change="selectMediaType" v-bind:model-value="myCardsFilters.media_type" check-value="audio" id="media-type-audio">
            <span slot="label">{{ $t('common.browse_filters.media_type.audio') }}</span>
          </Radio>

        </div>

        <div class="col-sm-4">
          <ul class="nav justify-content-end order-by-btns">
            <li class="nav-item">
              <a class="nav-link typography--color-secondary"
                 v-bind:class="{ active: myCardsFilters.order_by === 'updated_at' }"
                 v-on:click="selectOrderBy('updated_at')">{{ $t('common.browse_filters.order_by.recency') }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link typography--color-secondary"
                 v-bind:class="{ active: myCardsFilters.order_by === 'popularity' }"
                 v-on:click="selectOrderBy('popularity')">{{ $t('common.browse_filters.order_by.popularity') }}</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="row" v-if="loading">
        <div class="col-sm-6 col-md-4 col-lg-3" v-for="n in 4" v-bind:key="n">
          <div class="card-row">
            <DummyCard></DummyCard>
          </div>
        </div>
      </div>

      <div class="row" v-else>
        <div class="col-sm-6 col-md-4 col-lg-3" v-for="card in myCardList" v-bind:key="card.id">
          <div class="card-row">
            <MyCard
              v-bind:card="card"
              v-on:open-delete-modal="openDeleteModal"
              v-on:open-make-card-private-modal="openMakeCardPrivateModal"
              @onShareLevelSetupClick="handleShareLevelSetupClick"
            />
          </div>
        </div>

        <InfiniteLoading :on-infinite="onInfinite" ref="infiniteLoading" class="w-100">
          <div slot="spinner">
            <LoadingBounce></LoadingBounce>
            <div class="typography--body-2 typography--color-disabled pb-5">{{ $t('common.loading') }}</div>
          </div>

          <div slot="no-results" class="col-12 text-center mb-5 pb-5">
            <div v-if="myCardList.length === 0">
              <div class="empty-list-text typography--body-2 typography--color-disabled pt-4"
                   v-html="$t('my_cards.no_cards')">
              </div>
            </div>
          </div>
          <div slot="no-more"></div>
        </InfiniteLoading>
      </div>

    </div>

    <div slot="modal-area">
      <BasicModal id="delete-my-card-modal" v-bind:title="$t('common.modal.remove.title')" v-on:ok="deleteCard" v-on:cancel="cancelDeleteCard">
        <div v-html="$t('common.modal.remove.message')"></div>
      </BasicModal>

      <BasicModal id="make-card-private-modal"
        v-bind:title="$t('common.modal.make_private.title')" v-on:ok="makeCardPrivate" v-on:cancel="cancelMakeCardPrivate">
        <div v-html="$t('common.modal.make_private.message')"></div>
      </BasicModal>

      <b-modal id="no-class-to-assign-alert"
               class="basic-modal no-header-modal hide-cancel-btn"
               v-bind:hide-header="true"
               v-bind:ok-title="$t('common.confirm')">
        <div v-html="$t('common.modal.no_class_to_assign_alert.message')"></div>
      </b-modal>

      <MyCardShareSetupModal
        v-if="isMyCardShareSetupModal"
        :cardId="selectedCardId"
        :cardShareLevel="savedCardShareLevel"
        :onModalCancelClick="() => this.isMyCardShareSetupModal = false"
        :onModalOkClick="handleCardShareLevelUpdate"
        :isLoading="isLoadingCardShareLevel"
      />
    </div>

    <div slot="floating-action-menu" class="hidden-sm-up">
      <FloatingDropup>
        <b-dropdown-item to="/new-my-card">{{ $t('my_cards.sub_header.new_my_card') }}</b-dropdown-item>
      </FloatingDropup>
    </div>
  </MainLayout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isEmpty, debounce, isNil } from 'lodash';
  import InfiniteLoading from 'vue-infinite-loading';
  import labels from '@/mixins/labels';
  import MyCard from '../components/MyCard';
  import MyCardShareSetupModal from '../components/MyCardShareSetupModal';

  export default {
    name: 'my-cards',

    components: {
      InfiniteLoading,
      MyCard,
      MyCardShareSetupModal,
    },

    mixins: [
      labels,
    ],

    data() {
      return {
        loading: false,
        cardIdToDelete: null,
        cardIdToMakePrivate: null,
        isMyCardShareSetupModal: false,
        selectedCardId: null,
        savedCardShareLevel: null,
        isLoadingCardShareLevel: false,
      };
    },

    computed: {
      ...mapGetters([
        'trimmedMyCardsFilters',
        'checkedTutorials',
        'coreConceptList',
        'myCardsFilters',
        'coreConcepts',
        'myCardList',
        'subjectMap',
        'subjectIds',
        'gradeMap',
        'gradeIds',
        'unitList',
        'units',
        'subjectList',
        'gradeList',
        'gradeSubjects',
        'currentUser',
      ]),

      showTooltip() {
        if (!isEmpty(this.checkedTutorials) &&
            this.checkedTutorials.welcome &&
            !this.checkedTutorials.tryNewMyCard) {
          return true;
        }

        return false;
      },

      selectedSubjectGrade() {
        return `${this.myCardsFilters.subject_id}&${this.myCardsFilters.grade_id}`;
      },

      currentUnitList() {
        return this.unitList.filter(unit => (
          unit.subject_id === parseInt(this.myCardsFilters.subject_id, 10) &&
          // unit.grade_id === parseInt(this.myCardsFilters.grade_id, 10) &&
          unit.name !== 'NO NAME YET'
        ));
      },

      currentCoreConceptList() {
        return this.coreConceptList.filter(coreConcept => (
          coreConcept.subject_id === parseInt(this.myCardsFilters.subject_id, 10) &&
          coreConcept.grade_id === parseInt(this.myCardsFilters.grade_id, 10)
        ));
      },
    },

    watch: {
      gradeSubjects(state) {
        if (isEmpty(state)) {
          document.getElementById('subject-dropdown').firstElementChild.disabled = true;
        } else {
          document.getElementById('subject-dropdown').firstElementChild.disabled = false;
        }
      },

      currentCoreConceptList(state) {
        if (isEmpty(state)) {
          document.getElementById('core-concept-dropdown').firstElementChild.disabled = true;
        } else {
          document.getElementById('core-concept-dropdown').firstElementChild.disabled = false;
        }

        return !isEmpty(state);
      },

      currentUnitList(state) {
        if (isEmpty(state)) {
          document.getElementById('unit-dropdown').firstElementChild.disabled = true;
        } else {
          document.getElementById('unit-dropdown').firstElementChild.disabled = false;
        }

        return !isEmpty(state);
      },

      selectedSubjectGrade(state) {
        if (state.match(/^[0-9]+&0$/) || state.match(/^0&[0-9]+$/)) {
          return null;
        }

        if (!isNil(state.match(/[0-9]+&[0-9]+/))) {
          // if (this.getSchoolYear(this.gradeMap[this.myCardsFilters.grade_id]) > 6) {
          //   if (isEmpty(this.currentCoreConceptList)) {
          //     return this.fetchCoreConcepts({
          //       subject_id: this.myCardsFilters.subject_id,
          //       grade_id: this.myCardsFilters.grade_id,
          //     });
          //   }

          //   return null;
          // }

          return this.fetchUnits({
            subject_id: this.myCardsFilters.subject_id,
            grade_id: this.myCardsFilters.grade_id,
          });
        }

        return null;
      },
    },

    methods: {
      ...mapActions([
        'makeMyCardPrivateInStore',
        'setTutorialAsChecked',
        'fetchCoreConcepts',
        'setMyCardsFilter',
        'updateMyCard',
        'removeMyCard',
        'fetchMyCards',
        'fetchUnits',
        'fetchGradeSubjects',
        'resetGradeSubjects',
        'setMyCardShareLevel',
      ]),

      onTooltipClosed() {
        this.setTutorialAsChecked('tryNewMyCard');
      },

      goToNewMyCard() {
        if (!isEmpty(this.checkedTutorials) &&
            !this.checkedTutorials.tryNewMyCard) {
          return this.setTutorialAsChecked('tryNewMyCard')
            .then(() => {
              this.$router.push('/new-my-card');
            });
        }

        return this.$router.push('/new-my-card');
      },

      deleteCard() {
        this.removeMyCard(this.cardIdToDelete)
          .then(() => {
            this.cardIdToDelete = null;
          })
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      },

      cancelDeleteCard() {
        this.cardIdToDelete = null;
      },

      openDeleteModal(cardId) {
        this.cardIdToDelete = cardId;

        this.$root.$emit('show::modal', 'delete-my-card-modal');
      },

      makeCardPrivate() {
        const updateInfo = { share_level: 2 };

        return this.updateMyCard({ cardId: this.cardIdToMakePrivate, updateInfo })
          .then(() => (
            this.makeMyCardPrivateInStore(this.cardIdToMakePrivate)
          ))
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      },

      cancelMakeCardPrivate() {
        this.cardIdToMakePrivate = null;
      },

      openMakeCardPrivateModal(cardId) {
        this.cardIdToMakePrivate = cardId;

        this.$root.$emit('show::modal', 'make-card-private-modal');
      },

      handleShareLevelSetupClick(cardId, cardShareLevel) {
        this.selectedCardId = cardId;
        this.savedCardShareLevel = cardShareLevel;
        this.isMyCardShareSetupModal = true;
      },

      handleCardShareLevelUpdate(selectedMyCardShareLevel) {
        const updateInfo = { share_level: selectedMyCardShareLevel };

        this.isLoadingCardShareLevel = true;
        this.updateMyCard({ cardId: this.selectedCardId, updateInfo })
          .then(() => this.setMyCardShareLevel({
            cardId: this.selectedCardId,
            shareLevel: selectedMyCardShareLevel,
          }))
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          })
          .finally(() => {
            this.isLoadingCardShareLevel = false;
            this.isMyCardShareSetupModal = false;
          });
      },

      onInfinite() {
        this.setMyCardsFilter({ property: 'offset', value: this.myCardsFilters.offset + 20 })
          .then(() => (
            this.fetchMyCards(this.trimmedMyCardsFilters)
          ))
          .then((cardList) => {
            if (this.$refs.infiniteLoading) {
              if (cardList.length === 0) {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
              } else {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
              }
            }
          })
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      },

      selectSubject(subjectId) {
        if (this.myCardsFilters.subject_id !== subjectId) {
          this.setMyCardsFilter({ property: 'subject_id', value: subjectId })
            .then(() => (
              this.setMyCardsFilter({ property: 'core_concept_id', value: '0' })
            ))
            .then(() => (
              this.setMyCardsFilter({ property: 'unit_id', value: '0' })
            ))
            .then(() => (
              this.setMyCardsFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;

              return this.fetchMyCards(this.trimmedMyCardsFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectGrade(gradeId, schoolYear) {
        if (this.myCardsFilters.grade_id !== gradeId) {
          this.fetchGradeSubjects({ grade: schoolYear })
            .then(() => (
              this.setMyCardsFilter({ property: 'school_year', value: schoolYear })
            ))
            .then(() => (
              this.setMyCardsFilter({ property: 'grade_id', value: gradeId })
            ))
            .then(() => (
              this.setMyCardsFilter({ property: 'subject_id', value: '0' })
            ))
            .then(() => (
              this.setMyCardsFilter({ property: 'core_concept_id', value: '0' })
            ))
            .then(() => (
              this.setMyCardsFilter({ property: 'unit_id', value: '0' })
            ))
            .then(() => (
              this.setMyCardsFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;

              return this.fetchMyCards(this.trimmedMyCardsFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectCoreConcept(coreConceptId) {
        if (this.myCardsFilters.core_concept_id !== coreConceptId) {
          this.setMyCardsFilter({ property: 'core_concept_id', value: coreConceptId })
            .then(() => (
              this.setMyCardsFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;

              return this.fetchMyCards(this.trimmedMyCardsFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectUnit(unitId) {
        if (this.myCardsFilters.unit_id !== unitId) {
          this.setMyCardsFilter({ property: 'unit_id', value: unitId })
            .then(() => (
              this.setMyCardsFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;

              return this.fetchMyCards(this.trimmedMyCardsFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      selectMediaType(mediaType) {
        this.setMyCardsFilter({ property: 'media_type', value: mediaType })
          .then(() => (
            this.setMyCardsFilter({ property: 'offset', value: 0 })
          ))
          .then(() => {
            this.loading = true;

            return this.fetchMyCards(this.trimmedMyCardsFilters);
          })
          .then(() => {
            this.loading = false;
          })
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      },

      selectOrderBy(orderByParam) {
        if (this.myCardsFilters.order_by !== orderByParam) {
          this.setMyCardsFilter({ property: 'order_by', value: orderByParam })
            .then(() => (
              this.setMyCardsFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.loading = true;

              return this.fetchMyCards(this.trimmedMyCardsFilters);
            })
            .then(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },

      // eslint-disable-next-line func-names
      fetchWithSearchKeywords: debounce(function () {
        this.loading = true;

        this.fetchMyCards(this.trimmedMyCardsFilters)
          .then(() => {
            this.loading = false;
          })
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      }, 500),

      applySearchKeywords(inputText) {
        if (this.myCardsFilters.search_keywords !== inputText) {
          this.setMyCardsFilter({ property: 'search_keywords', value: inputText })
            .then(() => (
              this.setMyCardsFilter({ property: 'offset', value: 0 })
            ))
            .then(() => {
              this.fetchWithSearchKeywords();
            })
            .catch((err) => {
              this.$root.$emit('show::modal', 'basic-error-alert');
              return Promise.reject(err);
            });
        }
      },
    },

    mounted() {
      if (isEmpty(this.gradeSubjects)) {
        document.getElementById('subject-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('subject-dropdown').firstElementChild.disabled = false;
      }

      if (isEmpty(this.currentCoreConceptList)) {
        document.getElementById('core-concept-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('core-concept-dropdown').firstElementChild.disabled = false;
      }

      if (isEmpty(this.currentUnitList)) {
        document.getElementById('unit-dropdown').firstElementChild.disabled = true;
      } else {
        document.getElementById('unit-dropdown').firstElementChild.disabled = false;
      }
    },

    created() {
      this.resetGradeSubjects();
      this.loading = true;

      Promise.resolve()
        .then(() => (
          this.setMyCardsFilter({ property: 'grade_id', value: this.currentUser.grade_id })
        ))
        .then(() => (
          this.fetchGradeSubjects({ grade: this.currentUser.grade_id })
        ))
        .then(() => (
          this.setMyCardsFilter({ property: 'offset', value: 0 })
        ))
        .then(() => (
          this.fetchMyCards(this.trimmedMyCardsFilters)
        ))
        .then(() => {
          this.loading = false;
        })
        .then(() => {
          if (!isEmpty(this.checkedTutorials) && !this.checkedTutorials.welcome) {
            this.$root.$emit('show::modal', 'welcome-message-modal');
          }
        })
        .catch((err) => {
          console.error('err while fetching my cards in my cards view:', err);
          this.$root.$emit('show::modal', 'basic-error-alert');
          return Promise.reject(err);
        });
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/my-cards/views/MyCards.vue